/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { ProdottoDocument } from '@gql/graphql'
import ProdottoDetailTemplate from '@components/templates/ProdottoDetailTemplate/ProdottoDetailTemplate'
import useProdotti from '@hooks/useProdotti'

const ProdottoDetail = ({ pagina, prodotto }) => {
  const { prodotti, loading } = useProdotti([prodotto])

  return <ProdottoDetailTemplate pagina={pagina} prodotto={prodotti[0]} loading={loading} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/p/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { prodotto },
    } = await client.query({
      query: ProdottoDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!prodotto) {
      return {
        notFound: true,
      }
    }

    if (prodotto?.stato?.azione == 'A_301') {
      return {
        redirect: {
          newPath: prodotto?.categoria?.url ? prodotto?.categoria?.url : '/',
        },
      }
    }

    return {
      props: {
        pagina: prodotto.pagina,
        prodotto,
        key: prodotto.pk,
      },
      revalidate: 60 * 10,
    }
  },
  '/p/[slug]'
)

export default ProdottoDetail
